export const generateStatus = (item) => {
  if (item == 0) {
    return <span className="badge bg-success">ลงทะเบียนแล้ว</span>;
  } else if (item == 1) {
    return <span className="badge bg-primary">ยื่นคำขอฝึกงานแล้ว</span>;
  } else if (item == 2) {
    return (
      <span className="badge" style={{ background: "orange" }}>
        เตรียมออกหนังสือขอความอนุเคราะห์
      </span>
    );
  } else if (item == 3) {
    return (
      <span className="badge" style={{ background: "#1876D1" }}>
        ส่งหนังสือออก / รอบริษัทตอบรับ
      </span>
    );
  } else if (item == 11) {
    return (
      <span className="badge text-dark" style={{ background: "#F7F759" }}>
        กำลังตรวจสอบสถานประกอบการ
      </span>
    );
  } else if (item == 12) {
    return <span className="badge bg-success">อนุมัติคำร้องขอฝึกงาน</span>;
  } else if (item == 13) {
    return <span className="badge bg-danger">ติดต่ออาจารย์ผู้ประสานงาน</span>;
  } else if (item == 14) {
    return <span className="badge bg-danger">ไม่อนุมัติ</span>;
  } else if (item == 15) {
    return <span className="badge bg-danger">ยกเลิกคำร้อง</span>;
  } else if (item == 21) {
    return (
      <span className="badge text-dark" style={{ background: "#F1D507" }}>
        ออกหนังสือขอความอนุเคราะห์แล้ว
      </span>
    );
  } else if (item == 31) {
    return (
      <span className="badge text-dark" style={{ background: "#00FF15" }}>
        สถานประกอบการรับเข้าฝึกงาน
      </span>
    );
  } else if (item == 32) {
    return (
      <span className="badge bg-danger">สถานประกอบการไม่รับเข้าฝึกงาน</span>
    );
  }else if (item == 101) {
    return (
      <span className="badge bg-danger">ฝึกงาน 2 เดือน</span>
    );
  }else if (item == 102) {
    return (
      <span className="badge bg-danger">สหกิจศึกษา</span>
    );
  }else if (item == 100) {
    return (
      <span className="badge bg-danger">ยังไม่ได้ยื่นคำขอฝึกงาน</span>
    );
  }
  



};
